export const EYE_BLINK_MS = 400;
export const PAGE_LOADER_DELAY_MS = 800;

export {KEY_CODES} from './keyCodes';
